import React, { Component } from 'react'
import { getInvoiceData } from '../../services/Seller';
import InvoiceDetails from './InvoiceDetails';
import './InvoiceContainer.less'
import { Button, Dimmer, Dropdown, Form, Grid, Header, Icon, Loader, Menu, Modal, Pagination, Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import RequestDetailsModal from '../../components/RequestDetailsModal/RequestDetailsModal';
import Formsy from 'formsy-react';
import DGTextarea from '../../components/FormControls/Textarea/DGTextarea';
import { contactUsSubmit } from '../../services/User';
import { connect } from 'react-redux';

const paymentOptions = [
    { key: 'Commission', value: 'Commission', text: 'Lead Fee' },
    { key: 'Plan', value: 'Plan', text: 'Plan' },
    { key: '', value: 'All Invoices', text: 'All Invoices' },
]

const rowsPerPageOptions = [10, 20, 50].map(o => ({ key: o, value: o, text: o }))

class InvoiceContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoices: [],
            loading: false,
            totalPages: 0,
            currentPage: 1,
            type: 'Commission',
            itemsPerPage: 10,
            isModalOpen: false,
            selectedInvoice: {},
            isRequestDetailsModalOpen: false,
            isRequestRefundModalOpen: false,
            refundReqDetails: {}
        }
    }
    componentDidMount() {
        this.getInvoices(this.state.itemsPerPage, this.state.currentPage, this.state.type);
    }

    getInvoices = (itemsPerPage, page, type) => {
        this.showLoader();
        getInvoiceData(itemsPerPage, page, type).then(({ data }) => {
            if (data) {
                this.setState({ invoices: data, totalPages: data.length ? Math.ceil(Number(data[0].totalCount) / itemsPerPage) : 1, currentPage: page, type });
            } else {
                this.setState({ invoices: [] })
            }
            this.hideLoader();
        })
    }

    showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        this.setState({ loading: true })
    }

    hideLoader = () => {
        document.body.style.overflowY = 'unset'
        this.setState({ loading: false })
    }

    onPageChange = (e, data) => {
        this.setState({ currentPage: data.activePag })
        this.getInvoices(this.state.itemsPerPage, data.activePage, this.state.type);
    }

    onItemsPerPageChange = (e, data) => {
        this.setState({ itemsPerPage: data.value, currentPage: 1 })
        this.getInvoices(data.value, 1, this.state.type);
    }

    onInvoiceTypeChange = (e, data) => {
        this.setState({ type: data.value, itemsPerPage: 10, currentPage: 1 })
        this.getInvoices(10, 1, data.value);
    }

    onInvoiceSelected = (invoice) => {
        this.setState({ selectedInvoice: invoice, isModalOpen: true })
    }

    onModalClose = () => {
        this.setState({ selectedInvoice: {}, isModalOpen: false })
    }

    getBackgroundColor = (status) => {
        switch (status) {
            case 'Paid':
                return '#e6ffe66a'
            case 'Void':
                return '#e6f7ff'
            case 'Payment Processing':
                return '#ffffcc6a'
            case 'Overdue':
                return '#ffcccc6a'
            default:
                return 'white'
        }
    }

    onClearPayment = (type) => {
        if (type == 'Commission') {
            this.props.history.push('/pending-commission-payments')
        } else if (type == 'Plan') {
            this.props.history.push('/inactive-subscription')
        }
    }

    openRequestDetailsModal = (singleBuyerRequestID) => {
       this.setState({singleBuyerRequestID, isRequestDetailsModalOpen: true})
    }

    onRequestRefundSubmit = () => {
        const { refundReqDetails } = this.state;
        contactUsSubmit({
            subject: 'Outside Radius report',
            email: this.props.currentUser.Seller.email,
            message: Object.keys(refundReqDetails).map(key => `${key}: ${refundReqDetails[key]}\n`).join('')
        }).then(res => {
            if (res.resStatus == 200) {
                this.setState({ refundReqDetails: {}, isRequestRefundModalOpen: false })
            }
        })
    }

    onRequestRefundClick = (invoice) => {
        this.setState({ refundReqDetails: { requestID: invoice.singleBuyerRequestID }, isRequestRefundModalOpen: true })
    }

    render() {
        const { invoices, currentPage, totalPages, itemsPerPage, type, isModalOpen, selectedInvoice } = this.state;
        const hasAnyCommissionPayment = invoices.some(i => i.type == "Commission");
        return <div className='invoice-container'>
            <Segment.Group>
                <Segment size="massive" className="no-radius">
                    <Header as="h1">
                        <Header.Content>
                            <Icon name='book' size='small' />
                                Payments
                            </Header.Content>
                    </Header>
                </Segment>
            </Segment.Group>
            {this.state.loading ? <Dimmer active>
                <Loader indeterminate size='massive' />
            </Dimmer> : ''}
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='5'>
                            <span>
                                <span> Filter by Invoice Type : </span>
                                <Dropdown
                                    inline
                                    options={paymentOptions}
                                    value={type}
                                    onChange={this.onInvoiceTypeChange}
                                />
                            </span>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                {window.innerWidth >= 768 ? <Table.Header>
                    <Table.Row>
                        {hasAnyCommissionPayment ? <Table.HeaderCell></Table.HeaderCell> : ''}
                        <Table.HeaderCell>Issued</Table.HeaderCell>
                        <Table.HeaderCell>Invoice Type</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'>Amount</Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                </Table.Header> : ''}
                <Table.Body>
                    {window.innerWidth >= 768 ? invoices.map(i => <Table.Row style={{ backgroundColor: this.getBackgroundColor(i.invoiceStatus) }}>
                        {hasAnyCommissionPayment ? <Table.Cell>
                            {i.type == 'Commission' ? <Button size='big' color='facebook' className='invoice-details-btn' onClick={() => this.openRequestDetailsModal(i.singleBuyerRequestID)}> Request Details </Button> : ''}
                        </Table.Cell> : ''}
                        <Table.Cell>{moment(i.createdAt).format('LL')}</Table.Cell>
                        <Table.Cell>{i.type == "Commission" ? "Lead Fee" : i.type}</Table.Cell>
                        <Table.Cell>{i.invoiceStatus}</Table.Cell>
                        <Table.Cell textAlign='right'>$ {i.items.map(i => i.amount).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)}</Table.Cell>
                        <Table.Cell>
                            <Button size='big' color='green' className='invoice-details-btn' onClick={() => this.onInvoiceSelected(i)}> Invoice Details </Button>
                            {i.invoiceStatus == 'Overdue' ? <Button size='big' color='blue' className='invoice-details-btn' onClick={() => this.onClearPayment(i.type)}> Clear Payment </Button> : ''}
                            {/*{i.singleBuyerRequestID && i.invoiceStatus != 'Overdue' ? <Button size='big' color='blue' className='invoice-details-btn' onClick={() => this.onRequestRefundClick(i)}> Report Out of Radius</Button> : ''} */}
                        </Table.Cell>
                    </Table.Row>) : invoices.map(i => <Table.Row style={{ backgroundColor: this.getBackgroundColor(i.invoiceStatus) }}>
                        {hasAnyCommissionPayment ? <Table.Cell>
                            {i.type == 'Commission' ? <Button color='facebook' className='invoice-details-btn' onClick={() => this.openRequestDetailsModal(i.singleBuyerRequestID)}> Requested Details </Button> : ''}
                        </Table.Cell> : ''}
                        <Table.Cell>Issued: {moment(i.createdAt).format('LL')}</Table.Cell>
                        <Table.Cell>Invoice Type: {i.type == "Commission" ? "Lead Fee" : i.type}</Table.Cell>
                        <Table.Cell>Status: {i.invoiceStatus}</Table.Cell>
                        <Table.Cell textAlign='right'>Amount: $ {i.items.map(i => i.amount).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)}</Table.Cell>
                        <Table.Cell>
                            <Button color='green' className='invoice-details-btn' onClick={() => this.onInvoiceSelected(i)}> Invoice Details </Button>
                            {i.invoiceStatus == 'Overdue' ? <Button color='blue' className='invoice-details-btn' onClick={() => this.onClearPayment(i.type)}> Clear Payment </Button> : ''}
                            {/*{i.singleBuyerRequestID && i.invoiceStatus != 'Overdue' ? <Button color='blue' className='invoice-details-btn' onClick={() => this.onRequestRefundClick(i)}> Report Out of Radius </Button> : ''} */}
                        </Table.Cell>
                    </Table.Row>)}
                    {!invoices.length ? <Table.Row>
                        <Table.Cell colSpan={4}>No Payments found.</Table.Cell>
                    </Table.Row> : ''}
                </Table.Body>
                <Table.Footer>
                    {invoices.length ? <Table.Row>
                        <Table.HeaderCell textAlign='left' colSpan='2'>
                            <span>
                                <span className='type-filter-dropdown-title'> Rows per page : </span>
                                <Dropdown
                                    className='type-filter-dropdown'
                                    inline
                                    options={rowsPerPageOptions}
                                    value={itemsPerPage}
                                    onChange={this.onItemsPerPageChange}
                                />
                            </span>
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign='right' colSpan='3'>
                            <Pagination activePage={currentPage} totalPages={totalPages} onPageChange={this.onPageChange} />
                        </Table.HeaderCell>
                    </Table.Row> : ''}
                </Table.Footer>
            </Table>
            <Modal
                centered={false}
                open={isModalOpen}
                onClose={this.onModalClose}
            >
                <Modal.Header>Invoice Details</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <InvoiceDetails invoice={selectedInvoice} />
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onModalClose}>OK</Button>
                </Modal.Actions>
            </Modal>
            <Modal size='small' open={this.state.isRequestRefundModalOpen} onClose={() => this.setState({ isRequestRefundModalOpen: false, refundReqDetails: {} })} centered={false} >
                <Modal.Header style={{ fontSize: '14px' }}>Please describe reason for reporting out of radius</Modal.Header>
                <Modal.Content>
                    <Formsy onValidSubmit={this.onRequestRefundSubmit}>
                        <DGTextarea
                            name='info-request'
                            validationErrors={{
                                isDefaultRequiredValue: 'Please describe the reason for reporting out of radius'
                            }}
                            onChange={(e, data) => this.setState({ refundReqDetails: { ...this.state.refundReqDetails, reason: data.value } })}
                            required
                            placeholder='Please provide as much detail as possible'
                            value={this.state.refundReqDetails.reason}
                            style={{ minHeight: 100, width: '100%', fontSize: '14px', margin: '1rem', minHeight: '100px', padding: '10px', width: 'calc(100% - 2rem)' }} />
                        <Grid padded>
                            <Grid.Column width={16} textAlign='right'>
                                <Button primary size='large' >Submit</Button>
                                <Button size='large' onClick={() => this.setState({ isRequestRefundModalOpen: false, refundReqDetails: {} })}>Close</Button>
                            </Grid.Column>
                        </Grid>
                    </Formsy>
                </Modal.Content>

            </Modal>
            <RequestDetailsModal
                closeHandler={() => this.setState({ isRequestDetailsModalOpen: false })}
                open={this.state.isRequestDetailsModalOpen}
                singleBuyerRequestID={this.state.singleBuyerRequestID}
            />
        </div>
    }
}

const mapStateToProps = ({ auth: { currentUser } }) => {
    return { currentUser };
}

export default connect(mapStateToProps, null)(InvoiceContainer)